import { css } from "styled-components/macro";
export const sizes = {
  xlg: 1440,
  lg: 1200,
  md: 992,
  sm: 768,
  xs: 500,
};

export const mediaMin: {
  xlg?: any;
  lg?: any;
  md?: any;
  sm?: any;
  xs?: any;
} = Object.keys(sizes).reduce((accumulator, label) => {
  // @ts-ignore
  const emSize = sizes[label] / 16;
  // @ts-ignore
  accumulator[label] = (first, ...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(first, ...args)};
    }
  `;
  return accumulator;
}, {});
